module.exports = __webpack_public_path__ + "img/white-grad.fd9115fc.png";